import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { thirdFlowsActions } from 'features/thirdFlows';

const useThirdFlows = () => {
  const dispatch = useDispatch();
  const getThirdFlow = useCallback(() => dispatch(thirdFlowsActions.getThirdFlow()), [dispatch]);
  const createThirdFlow = useCallback(third_flow => dispatch(thirdFlowsActions.createThirdFlow(third_flow)), [dispatch]);
  const updateThirdFlow = useCallback(third_flow => dispatch(thirdFlowsActions.updateThirdFlow(third_flow)), [dispatch]);
  const deleteThirdFlow = useCallback(() => dispatch(thirdFlowsActions.deleteThirdFlow()), [dispatch]);
  const clearLocalActiveThirdFlow = useCallback(() => dispatch(thirdFlowsActions.clearLocalActiveThirdFlow()), [dispatch]);

  return {
    getThirdFlow,
    createThirdFlow,
    updateThirdFlow,
    deleteThirdFlow,
    clearLocalActiveThirdFlow
  };
};

export default useThirdFlows;